import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import "./Navbar2.css";
import maffick_techno from "./img/maffick_techno.png";
import manit from "./img/manit.png";

function Navbar2({ onContentChange }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Toggle menu + hide typetext
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.classList.toggle("menu-open");
  };

  // Close menu + show typetext
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.classList.remove("menu-open");
    const hamburger = document.querySelector(".hamburger");
    if (hamburger) hamburger.classList.remove("active");
  };

  // Cleanup on unmount
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") closeMobileMenu();
    };
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.classList.remove("menu-open");
    };
  }, []);

  return (
    <>
      <div>
        <nav className="navbar" id="navbar">
          <div className="nav-container">
            {/* MANIT Logo */}
            <Link className="navbar-brand-logo" to="/">
              <img src={manit} width="90" height="70" alt="MANIT" />
            </Link>
            
            {/* Maffick Logo */}
            <Link className="navbar-brand logo" to="/">
              <img src={maffick_techno} width="90" height="70" alt="Maffick Techno" />
            </Link>

            {/* Desktop Links */}
            <ul className={`nav-links ${isMobileMenuOpen ? "mobile-open" : ""}`}>
              <li><Link to="/Events" onClick={closeMobileMenu}>EVENTS</Link></li>
              <li><Link to="/Competitions" onClick={closeMobileMenu}>COMPETITIONS</Link></li>
              <li><Link to="/Timeline" onClick={closeMobileMenu}>TIMELINE</Link></li>
              <li><Link to="/Merch" onClick={closeMobileMenu}>MERCHANDISE</Link></li>
              <li><Link to="/Sponsor" onClick={closeMobileMenu}>SPONSORSHIP</Link></li>
              <li><Link to="/Maffick" onClick={closeMobileMenu}>OUR TEAM</Link></li>
            </ul>

            {/* Hamburger Menu */}
            <div
              className={`hamburger ${isMobileMenuOpen ? "active" : ""}`}
              onClick={toggleMobileMenu}
              role="button"
              tabIndex={0}
              aria-label="Toggle navigation menu"
              onKeyDown={(e) => e.key === "Enter" && toggleMobileMenu()}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Mobile Overlay Menu */}
          {isMobileMenuOpen && (
            <div 
              className="mobile-menu-overlay" 
              onClick={closeMobileMenu}
            >
              <div className="mobile-nav-links">
                <Link to="/Events" onClick={closeMobileMenu}>EVENTS</Link>
                <Link to="/Competitions" onClick={closeMobileMenu}>COMPETITIONS</Link>
                <Link to="/Timeline" onClick={closeMobileMenu}>TIMELINE</Link>
                <Link to="/Merch" onClick={closeMobileMenu}>MERCHANDISE</Link>
                <Link to="/Sponsor" onClick={closeMobileMenu}>SPONSORSHIP</Link>
                <Link to="/Maffick" onClick={closeMobileMenu}>OUR TEAM</Link>
              </div>
            </div>
          )}
        </nav>

        {/* Content spacer */}
        <div className="h-16" id="content-to-change">
          {onContentChange ? onContentChange() : null}
        </div>
      </div>
    </>
  );
}

export default Navbar2;
